import { render, staticRenderFns } from "./firmwareTask_detail_dialog.vue?vue&type=template&id=b04f64a6"
import script from "./firmwareTask_detail_dialog.vue?vue&type=script&lang=js"
export * from "./firmwareTask_detail_dialog.vue?vue&type=script&lang=js"
import style0 from "./firmwareTask_detail_dialog.vue?vue&type=style&index=0&id=b04f64a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports